<script setup>
import { computed } from 'vue';
import { INVOICE_STATUS } from '../../constants/constants';
import CreateCreditNoteAction from '../actions/CreateCreditNoteAction.vue';
import DownloadInvoiceAction from '../actions/DownloadInvoiceAction.vue';
import SeeRelatedSubscriptionAction from '../actions/SeeRelatedSubscriptionAction.vue';
import CreatePartialCreditNoteAction from '../actions/CreatePartialCreditNoteAction.vue';
import MarkAsStatusAction from '../actions/MarkAsStatusAction.vue';
import SendPaymentReminderAction from '../actions/SendPaymentReminderAction.vue';
import useInvoiceModalStore from '../../store/invoiceModal';
import useInvoiceStore from '../../store/invoices';
import useSubscriptionStore from '../../store/subscriptions';
import MenuDropdown from '../../../../_02_molecules/components/MenuDropdown.vue';

const subscriptionStore = useSubscriptionStore();
const invoiceStore = useInvoiceStore();
const { setModal } = useInvoiceModalStore();

const subscriptionData = computed(() => subscriptionStore.selectedSubscriptionData);

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const openModal = ({ title, name }) => {
  invoiceStore.setSelectedInvoice(props.invoice);
  setModal({
    modalTitle: title,
    modalComponentName: name,
    shouldOpenModal: true,
  });
};

const invoiceStatus = computed(() => props.invoice.status?.toLowerCase() ?? null);
</script>

<template>
  <MenuDropdown v-if="invoice">
    <template #start>
      <ul>
        <template v-if="[ INVOICE_STATUS.OPEN, INVOICE_STATUS.PAYMENT_OVERDUE ].includes(invoiceStatus)">
          <CreateCreditNoteAction @openModal="openModal" />
          <CreatePartialCreditNoteAction @openModal="openModal" />
          <MarkAsStatusAction :type="invoice.type" :status="INVOICE_STATUS.PAID" @openModal="openModal" />
          <MarkAsStatusAction :type="invoice.type" :status="INVOICE_STATUS.UNRECOVERABLE" @openModal="openModal" />
        </template>

        <template v-else-if="invoiceStatus === INVOICE_STATUS.PARTIALLY_PAID">
          <CreatePartialCreditNoteAction @openModal="openModal" />
          <MarkAsStatusAction :type="invoice.type" :status="INVOICE_STATUS.PAID" @openModal="openModal" />
        </template>

        <template v-else-if="invoiceStatus === INVOICE_STATUS.PAID">
          <CreateCreditNoteAction @openModal="openModal" />
        </template>

        <DownloadInvoiceAction v-if="invoice.invoice_url" :invoice-url="invoice.invoice_url" class="dropdown-ubiq--separator" />
        <SeeRelatedSubscriptionAction v-if="!subscriptionData" :subscription-id="invoice.subscription?.id" class="dropdown-ubiq--separator" />

        <template v-if="invoiceStatus === INVOICE_STATUS.PAYMENT_OVERDUE">
          <SendPaymentReminderAction @openModal="openModal" />
        </template>
      </ul>
    </template>
  </MenuDropdown>
</template>
